module.exports = __webpack_public_path__ + "docs/domain-advertising-intro-1.0.pdf";